import { useAuthContext } from "../../../context/authContext";
import { FaRightFromBracket, FaHouse } from "react-icons/fa6";
import { HiBuildingOffice2 } from "react-icons/hi2";
import Logo from "../../../assets/img/logos/logoColor.png";
import { useState } from "react";

function DashboardContainer({ children }) {
  const { logout } = useAuthContext();
  const [isOpen, setIsOpen] = useState(false);

  const handleLogout = async () => {
    await logout();
  };

  return (
    <div>
      <nav className="bg-white border-b border-gray-200 fixed z-30 w-full">
        <div className="px-3 py-5 lg:px-5 lg:pl-3">
          <div className="flex items-center justify-between">
            <div className="flex items-center justify-between w-full">
              <a
                href="/dashboard"
                className="text-xl font-bold flex items-center lg:ml-2.5"
              >
                <img src={Logo} className="h-6 mr-2" alt="Windster Logo" />
                <span className="self-center whitespace-nowrap">
                  Inmobiliaria
                </span>
              </a>
              <button
                onClick={() => setIsOpen(!isOpen)}
                className="lg:hidden focus:outline-none mr-4 cursor-pointer"
              >
                <svg
                  className="w-6 h-6"
                  fill="none"
                  stroke="currentColor"
                  viewBox="0 0 24 24"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="2"
                    d={
                      isOpen ? "M6 18L18 6M6 6l12 12" : "M4 6h16M4 12h16m-7 6h7"
                    }
                  />
                </svg>
              </button>
            </div>
          </div>
        </div>
      </nav>
      <div className="flex overflow-hidden bg-white pt-16">
        <aside
          id="sidebar"
          className={`fixed z-20 h-full top-0 left-0 pt-16 flex flex-shrink-0 flex-col w-64 transition-width duration-75 ${
            isOpen ? "translate-x-0" : "-translate-x-full"
          } lg:translate-x-0`}
          aria-label="Sidebar"
        >
          <div className="relative flex-1 flex flex-col min-h-0 border-r border-gray-200 bg-white pt-0">
            <div className="flex-1 flex flex-col pt-5 pb-4 overflow-y-auto">
              <div className="flex-1 px-3 bg-white divide-y space-y-1">
                <ul className="space-y-2 pb-2">
                  <li>
                    <a
                      href="/dashboard"
                      className="text-base text-gray-900 font-normal rounded-lg flex items-center p-2 hover:bg-gray-100 group"
                    >
                      <FaHouse className="w-6 h-6 text-gray-500 group-hover:text-gray-900 transition duration-75" />
                      <span className="ml-3">Home</span>
                    </a>
                  </li>
                  <li>
                    <a
                      href="/dashboard/propiedades"
                      className="text-base text-gray-900 font-normal rounded-lg hover:bg-gray-100 flex items-center p-2 group"
                    >
                      <HiBuildingOffice2 className="w-6 h-6 text-gray-500 group-hover:text-gray-900 transition duration-75" />
                      <span className="ml-3 flex-1 whitespace-nowrap">
                        Propiedades
                      </span>
                    </a>
                  </li>
                </ul>
              </div>
              <div className="space-y-2 pt-2 border-t border-gray-200">
                <button
                  className="text-gray-600 hover:text-gray-800 transition-colors duration-200 flex items-center p-2 group w-full"
                  onClick={handleLogout}
                >
                  <FaRightFromBracket className="w-6 h-6 text-gray-500 group-hover:text-gray-900 transition duration-75" />
                  <span className="mx-4 font-medium">Salir</span>
                </button>
              </div>
            </div>
          </div>
        </aside>
        <div
          className={`bg-gray-900 opacity-50 fixed inset-0 z-10 ${
            isOpen ? "block" : "hidden"
          } lg:hidden`}
          id="sidebarBackdrop"
          onClick={() => setIsOpen(false)}
        ></div>
        <div
          id="main-content"
          className="h-[93vh] w-full bg-gray-50 relative overflow-y-auto lg:ml-64 py-6"
        >
          <main>{children}</main>
        </div>
      </div>
    </div>
  );
}

export default DashboardContainer;
